import React, { memo } from 'react'

import Text from './Text'

const DefaultText = ({ sx, noMargin = false, ...restProps }) => {
  return (
    <Text
      variant='body1'
      component='div'
      sx={{
        ...(!noMargin && { mt: 1, mb: 2 }),
        fontSize: '1.125rem',
        '& > p, & > ul, & > ol': {
          mt: 0
        },
        '& > h3': {
          mb: 0
        },
        ...sx
      }}
      {...restProps}
    />
  )
}

export default memo(DefaultText)
